/*  eslint-disable */

import { makeStyles } from '@material-ui/core/styles';
import { colors } from 'styles/colors';

const useStyles = makeStyles({
  root: {
    margin: '10px 0',
    flexGrow: 1,

    '& .MuiInputBase-root': {
      height: '40px',

      ' .MuiAutocomplete-popper': {
        height: '700px',
      },
    },
  },

  iconButton: {
    '& .MuiIconButton-root': {
      color: colors.black,
    },
  },
});

export default useStyles;
